"use client";

//styles
import * as S from "./styles";

//types
import { ContainerProps } from "@/types/layouts/container";

import React from "react";

const Container: React.FC<ContainerProps> = ({ children, className }) => {
  return <S.Container className={className}>{children}</S.Container>;
};

export default Container;
